<template>
    <div class="hidden sm:block">
        <div class="py-8">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>

    <div class="sm:hidden block">
        <div class="sm:mt-0 mt-8"></div>
    </div>
</template>
